<template>
  <section class="notices card !bg-beige-40 text-article">
    <h3 class="title">{{ $t('product_notice_items') }}</h3>
    <bullet-text v-if="props.product?.notices" class="py-4" :content="props.product?.notices" />
    <nd-collapse class="!px-0" :list="noticeCollapseData" divider>
      <template #content="{ item }">
        <div class="flex flex-col content-wrapper text-base pb-4">
          <bullet-text v-if="item.content" :content="item.content" />
          <div v-else class="cancel-and-reschedule">
            <h4>{{ $t('cancellation_policy') }}</h4>
            <bullet-text :content="item.cancelRules" />
            <h4>{{ $t('reschedule_policy') }}</h4>
            <bullet-text :content="item.rescheduleRules" />
          </div>
        </div>
      </template>
    </nd-collapse>
  </section>
</template>

<script setup lang="ts">
import BulletText from '@/components/common/bullet-text.vue'

import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()

const { t } = useI18n()

const noticeCollapseData = computed(() => {
  if (!props.product) return []

  return [
    {
      title: t('customer_must_know'),
      content: props.product.need_to_know,
    },
    {
      title: t('cancel_change_time_policy'),
      cancelRules: props.product.cancel_rules,
      rescheduleRules: props.product.reschedule_rules,
      custom: true,
    },
  ]
})
</script>

<style lang="scss" scoped></style>
